<!-- contactUs -->
<template>
  <div class="officialUrl">
    <el-form-item label="官方网址：" prop="officialUrl">
      <el-input v-model="ruleForm.officialUrl" type="text" class="fl" style="width: 50%;" />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'officialUrl',
  data() {
    return {}
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
